import { tv, type VariantProps } from 'tailwind-variants';
export type OrThreeBlocksVariants = VariantProps<typeof orThreeBlocksVariants>;

const orThreeBlocksVariants = tv({
  slots: {
    base: 'container',
    cardsContainer:
      'm-auto gap-7 grid md:grid-cols-12 md:grid-rows-2 md:gap-13 md:h-773',
    mainCardStyles: 'min-h-515 h-full md:row-span-2',
    complementaryCard: 'font-Figtree',
  },
  variants: {
    complementaryCardsLength: {
      '1': { complementaryCard: 'min-h-350' },
      '2': { complementaryCard: 'min-h-150' },
    },
    topSpacing: {
      xs: 'pt-xs',
      sm: 'pt-sm',
      md: 'pt-md',
      lg: 'pt-lg',
      xl: 'pt-xl',
    },
    bottomSpacing: {
      xs: 'pb-xs',
      sm: 'pb-sm',
      md: 'pb-md',
      lg: 'pb-lg',
      xl: 'pb-xl',
    },
  },
  compoundVariants: [],
});

export default orThreeBlocksVariants;
